import { render, staticRenderFns } from "./ModuleDocumentPage.vue?vue&type=template&id=d9188cea&scoped=true&"
import script from "./ModuleDocumentPage.vue?vue&type=script&lang=js&"
export * from "./ModuleDocumentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9188cea",
  null
  
)

export default component.exports